module.exports = __webpack_public_path__ + "img/3_79.8a80fe4c.png";